import { ref, Ref } from "vue"

/**
 * Check if the inner container is overflowing the outer container.
 * @param outerContainer
 * @param innerContainer
 */
export const useOverflowCheck = (
  outerContainer: Ref<HTMLElement>,
  innerContainer: Ref<HTMLElement>
) => {
  const isOverflowing = ref(false)

  const checkOverflowing = () => {
    const _outerContainer = outerContainer.value
    const _innerContainer = innerContainer.value
    if (_outerContainer && _innerContainer) {
      isOverflowing.value =
        _innerContainer.scrollWidth > _outerContainer.clientWidth
    }
  }

  const resizeObserver = ref(null)

  const registerOverflowCheck = () => {
    checkOverflowing()
    window.addEventListener("resize", checkOverflowing)
    resizeObserver.value = new ResizeObserver(checkOverflowing)
    resizeObserver.value.observe(innerContainer.value)
  }

  const unregisterOverflowCheck = () => {
    window.removeEventListener("resize", checkOverflowing)
    resizeObserver.value?.disconnect()
  }

  return {
    isOverflowing,
    registerOverflowCheck,
    unregisterOverflowCheck,
  }
}
